import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((msg, type = 'info', duration = 4000) => {
    const id = Date.now();
    setToasts(prev => {
      const next = [...prev, { id, msg, type }];
      return next.slice(-3); // max 3 toasts
    });
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  const success = useCallback((msg) => addToast(msg, 'success'), [addToast]);
  const error   = useCallback((msg) => addToast(msg, 'error', 6000), [addToast]);
  const info    = useCallback((msg) => addToast(msg, 'info'), [addToast]);
  const remove  = useCallback((id) => setToasts(prev => prev.filter(t => t.id !== id)), []);

  return (
    <ToastContext.Provider value={{ success, error, info }}>
      {children}
      <div className="toast-container" data-testid="toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast-${t.type}`} data-testid={`toast-${t.type}`}>
            <span className="toast-icon">
              {t.type === 'success' ? '✓' : t.type === 'error' ? '✕' : 'i'}
            </span>
            <div className="toast-body">
              <div className="toast-title">
                {t.type === 'success' ? 'Succès' : t.type === 'error' ? 'Erreur' : 'Info'}
              </div>
              <div className="toast-msg">{t.msg}</div>
            </div>
            <button className="toast-close" onClick={() => remove(t.id)}>×</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}

export default ToastContext;
